import styled from 'styled-components';

export const DatesContainer = styled.div`
  display: flex;
  flex: row;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 2rem;
`;

export const EmptyContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: var(--app-font);
  font-size: 1.5rem;
  min-height: 50vh;
`;

export default {
  DatesContainer,
  EmptyContainer,
};
